import React from "react";
import "./intro.style.css";
import profileImg from "./profile.jpg";

const Intro = () => {
  return (
    <section
      className="intro_main"
      id="intro"
      itemScope
      itemType="https://schema.org/Person"
      aria-labelledby="intro-main-heading"
    >
      {/* Invisible SEO metadata (no UI impact) */}
      <meta itemProp="name" content="Swagat Vyas" />
      <meta itemProp="jobTitle" content="MD & CEO" />
      <meta itemProp="worksFor" content="Vishwanath Builders" />
      <meta itemProp="address" content="Gujarat, India" />

      {/* MAIN HERO HEADING (UNCHANGED TEXT) */}
      <h1
        id="intro-main-heading"
        className="intro_title"
        itemProp="headline"
      >
        Crafting landmarks, revolutionizing real estate,
        <br />
        and creating legacies
      </h1>

      <div className="intro">
        <div className="intro-left">
          <img
            className="intro-profile"
            src={profileImg}
            alt="Swagat Vyas, MD & CEO of Vishwanath Builders"
            loading="eager"
            itemProp="image"
          />
        </div>

        <div className="intro-right">
          <h2 className="intro-title" itemProp="name">
            Hi, I am Swagat Vyas
          </h2>

          <h4 className="intro-subtitle" itemProp="jobTitle">
            MD & CEO Of Vishwanath Builders
          </h4>

          <p className="intro-info" itemProp="description">
            Swagat Vyas, an industry leader with over a decade of experience,
            stands as a visionary force in the real estate sector. As the MD and
            CEO of Vishwanath Builders, a prominent real estate development
            company in Gujarat, he is pioneering the evolution of urban
            landscapes. Swagat Vyas actively supports young developers in
            reshaping the city's skyline. His commitment to leveraging the
            latest technology and innovation has been crucial in propelling his
            company's success.
            <br />
            <br />
            Under his leadership, Vishwanath Builders has delivered numerous
            high-quality projects that have set new benchmarks in the industry.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Intro;
